import { makeStyles } from "@material-ui/core/styles"
//todo use  color: theme.palette.primary.main, on filter button
const styles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minWidth: "fit-content",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "auto",
      marginRight: "auto",
      display: "flex",
      flexDirection: "column",
    },
  },
  leftButtonWrapper: {
    display: "flex",
    flexDirection: "row",
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  iconButton: {
    textTransform: "none",
    marginLeft: "10px",
    [theme.breakpoints.down("xs")]: {
      margin: 0,
    },
  },
  backArrow: {
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      left: 15,
      top: 0,
    },
  },
  forwardArrow: {
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      right: 15,
      top: 0,
    },
  },
  dateTextWrapper: {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      marginBottom: "10px",
    },
  },
  text: {
    fontFamily: "Oswald",
    fontWeight: "normal",
    fontSize: "24px",
    color: "#000",
    wordWrap: "break-word",
  },
  durationButtonContainer: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    display: "flex",
    flexDirection: "row",
  },
  durationButton: {
    backgroundColor: `${theme.palette.error.main} !important`,
    color: "#fff",
    height: "40px",
    textTransform: "none",
    marginLeft: "10px",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "5px",
      width: "50px",
    },
  },
  durationButtonOutlined: {
    backgroundColor: "#FAF7F7",
    color: theme.palette.error.main,
    height: "40px",
    textTransform: "none",
    marginLeft: "10px",
    border: `1px solid ${theme.palette.error.main}`,
    [theme.breakpoints.down("xs")]: {
      marginLeft: "5px",
      width: "50px",
    },
  },
}))

export default styles
